import { Input } from "antd";
import DateRangePicker from "app/components/shared/app/DateRangePicker";
import moment from "moment";
import React from "react";

export const accountUsersColumns = [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id'
    },
    {
        title: 'E-mail',
        dataIndex: 'email',
        key: 'v'
    },
    {
        title: 'Accepted',
        dataIndex: 'accepted',
        key: 'accepted',
        render: (d) => d ? "Accepted" : "Not Accepted",
    },
    {
        title: 'Role',
        dataIndex: 'role',
        key: 'role',
    }
]
// accountId: "10102255754736479"
// data: {currency: "USD", timezone: "America/Los_Angeles",…}
// dateLinked: "2021-09-02T00:53:48.782Z"
// name: "Facebook"
export const accountProviderColumns = [
    {
        title: 'Account Id',
        dataIndex: 'accountId',
        key: 'accountId'
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Currency',
        dataIndex: 'data',
        key: 'data',
        render: (d) => d?.currency,
    },
    {
        title: 'Timezone',
        dataIndex: 'data',
        key: 'data',
        render: (d) => d?.timezone,
    },
    {
        title: 'Date Linked',
        dataIndex: 'dateLinked',
        key: 'dateLinked',
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
    },
]
export const columns = [
    {
        title: 'Account ID',
        dataIndex: '_id',
        key: '_id',
        sorter: (a, b) => a._id.localeCompare(b._id),
        shouldUseAsfilter: false
    },
    {
        title: 'Account Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name),
        shouldUseAsfilter: true
    },
    {
        title: 'Account Currency',
        dataIndex: 'currency',
        key: 'currency',
        sorter: (a, b) => a?.currency.localeCompare(b?.currency),
        shouldUseAsfilter: true,
    },
    {
        title: 'Store Timezone',
        dataIndex: 'storeInfo',
        key: 'storeInfo',
        shouldUseAsfilter: false,
        sorter: (a, b) => a?.storeInfo?.timezone?.localeCompare(b?.storeInfo?.timezone),
        render: (d) => d?.timezone,
    },
    {
        title: 'Store Currency',
        dataIndex: 'storeInfo',
        key: 'storeInfo',
        shouldUseAsfilter: false,
        sorter: (a, b) => a?.storeInfo?.currency?.localeCompare(b?.storeInfo?.currency),
        render: (d) => d?.currency,
    },
    {
        title: 'Last Login',
        dataIndex: 'lastLogin',
        key: 'lastLogin',
        name: 'date',
        shouldUseAsfilter: true,
        sorter: (a, b) => a.name.localeCompare(b.name),
        render: (d) => {
            const beforeMonthDate = moment().subtract(1, "month");
            const loginDate = moment(d);
            return <p>{beforeMonthDate.toString() < loginDate.toString() ? <span>&#128681;</span> : ""}{loginDate.format('M/D/YYYY @ H:M:SS A')}</p>
        },
        filterComponent: ({ onFilterChange, ...props }) => {
            return <DateRangePicker onDateConfirm={onFilterChange} {...props} />
        }
    }
]

export const formSchema = [
    {
        props: {
            name: "name",
            label: "Account Name"
        },
        component: Input,
    },
    {
        props: {
            name: "currency",
            label: "Currency"
        },
        component: Input,
    }
]